import React, { lazy, useEffect, useState, useContext } from "react";
import { FlexColumn, FlexRow, SmallText, SLNotification, SLGridLayout, SLRowLayout, CompactCol, MediumText } from "../../components/core/utility";
import { Title } from "@vds/typography";
import { ValidateVehicleAddress } from "./ValidateVehicleAddress";
import { css } from "@emotion/react";
import styled from "styled-components";
import { generate } from "shortid";
import useOutsideClick from "../../customHook/use-outside-click";
import { Input, Toggle, TextArea, Checkbox } from "@vds/inputs";
import { EMAIL_REGEX_C360, QUANTITY_REGEX } from "../../constants/ValidationConstants";
import { ADD_VEHICELS_ASSIGNMENT_LIST_COLS } from "../../constants/AddVehicleAssignmentConstants";
import { AddVehicleAssignmentGrid } from "./AddVehicleAssignemntGrid";
import { Icon } from "@vds/icons";
import { switchTab } from "./utils";
import { VIN_REGEX } from "../../constants/C4SValidationConstants";
import { DropdownSelect } from "@vds/selects";
import { getVehicleMake } from "../../services/C4S Decommission - Replacement/getVehicleMake";
import { getVehicleModel } from "../../services/C4S Decommission - Replacement/getVehicleModel";
import { validateVin, saveVin } from "../../services/C4S Decommission - Replacement/validateVin";
import { C4SContext } from "../../context/c4sContext";

import { Button } from "@vds/buttons";
import { Loader } from "@vds/loaders";
import DeleteModal from "./DeleteModal";

const CustomCheckbox = styled(Checkbox)`
  margin: 0.5rem;
  & span {
    & span {
      & p {
        font-size: 12px !important;
        font-weight: normal !important;
        font-family: Verizon-NHG-eTX !important;
      }
    }
  }
`;
const HistoricalAddressRow = css`
  @media screen and (min-width: 910px) {
    width: 50%;
    max-width: 37.25rem;
    min-width: 4.125rem;
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const FullWidthFormSection = styled.div`
  & * {
    max-width: 100%;
  }
  & ${StatusWrapper} * {
    max-width: unset;
  }
`;

export const CustomInput = styled(Input)`
  padding-bottom: 0.5rem;
  height: auto;
  width: 100%;
  max-width: 100%;
  & * {
    max-width: 100%;
  }
  & label {
    & p {
      font-size: 12px;
      font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "400")};
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
    }
  }
  & span {
    & span {
      & span {
        width: ${(props) => (props.boxWidth ? props.boxWidth : "")};
      }
    }
  }
  & input {
    font-size: 12px;
    height: ${(props) => (props.height ? props.height : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      border-top: 1px solid #dfe0e0;
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
  & span {
    width: ${(props) => (props.width ? props.width : "")};
    & span {
      & span {
        & div:not(:first-child) {
          & svg {
            display: none; // hide success tick icon
          }
        }
      }
    }
  }
`;

export const CustomDropdown = styled(DropdownSelect)`
  width: 100%;
  max-width: 100%;
  & * {
    max-width: 100%;
  }
  & div {
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
    padding-right: ${(props) => (props.paddingRight ? props.paddingRight : "")};
    & label {
      & p {
        font-size: 12px;
        color: ${(props) => (props.disabled ? "#d8dada" : "")};
        & span {
          &::after {
            color: #747676;
          }
        }
      }
    }
    & span{
      & span{
        & div{
          & span{
            & svg{
              display:${(props) => (props.hideErrorImg ? "none !important" : "")};
            }
          }
        }
      }
    }
  }
  }
  & select {
    font-size: 12px;
    color: ${(props) => (props.disabled || props.disableValue ? "#666b6b" : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      // color: ${(props) => (props.disabled || props.disableValue ? "#d8dada" : "")};
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
`;

export default function AddVehicleAssignment(props) {
  const { cspDetails, workTicketInfo } = useContext(C4SContext);
  const [isLoading, setLoader] = useState(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState(false);
  const [productInfo] = useState(props.productInfo); // Assuming productInfo is passed as a prop
  const [featureValues, setFeatureValues] = useState("");
  const [notification, setNotification] = useState(null);
  const [address, setAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    latitude: "",
    longitude: "",
    locusSuggestedAddress: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
  });
  const [wheelChair, setWheelChair] = useState(false);
  const [killSwitch, setKillSwitch] = useState(false);
  const [ambulance, setAmbulance] = useState(false);
  const [isAddBtnDisabled, setIsAddBtnDisabled] = useState(true);
  const [vehicleSubscriptions, setVehicleSubscriptions] = useState([]);
  const [vinValue, setVinValue] = useState({
    value: "",
    error: false,
    errorText: "Enter name",
    success: false,
  });

  const [name, setName] = useState({
    value: "",
    error: false,
    errorText: "Enter name",
    success: false,
  });
  const [phone, setPhone] = useState({
    value: "",
    error: false,
    errorText: "Enter phone",
    success: false,
  });
  const [email, setEmail] = useState({
    value: "",
    error: false,
    errorText: "Enter email",
    success: false,
  });
  const [isToggle, setIsToggle] = useState(false);
  const [quantity, setQuantity] = useState({
    value: "",
    error: false,
    errorText: "Enter quantity",
    success: false,
  });
  const [updatedVehicles, setUpdatedVehicles] = useState([]);
  const [disableRight, setDisableRight] = useState(true);
  const [pendingAssignment, setPendingAssignment] = useState(null);
  const [bundleCount, setBundleCount] = useState(0);
  const [allowedVins, setAllowedVins] = useState([]);
  const [salesOrg, setSalesOrg] = useState({ value: "", error: false, errorText: "Please validate the Sales Org.", success: false });
  const [yearList, setYearList] = useState([]);
  const [makeList, setMakeList] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [year, setYear] = useState({
    value: "",
    error: false,
    errorText: "Please validate the Year.",
    success: false,
  });

  const [make, setMake] = useState({
    value: "",
    error: false,
    errorText: "Please validate the Make.",
    success: false,
  });

  const [model, setModel] = useState({
    value: "",
    error: false,
    errorText: "Please validate the Model.",
    success: false,
  });

  const handleClickOutside = () => {
    setNotification(null);
  };
  const clickRef = useOutsideClick(handleClickOutside);
  useEffect(() => {
    const data = productInfo
      .map((item) => item.Feature)
      .reduce((prev, curr) => {
        if (curr?.length > 0) {
          return [prev, ", ", curr];
        } else {
          return [prev, "", curr];
        }
      });
    setFeatureValues(data);
    if (cspDetails.cspDetails.cspData?.data?.data?.CSP.length > 0) {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CSP[0].CSPContactName);
      handleFields("Email", cspContactDetails.CSP[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CSP[0].CSPContactPhone, "", true);
    } else {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CASEDetails[0].CSPContactName);
      handleFields("Email", cspContactDetails.CASEDetails[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CASEDetails[0].CSPContactPhone, "", true);
    }
    setPendingAssignment(props.availableQty);
    setBundleCount(props.availableQty - updatedVehicles.length);
    getYearRange();
    getVehicleSubscriptions();
  }, []);

  useEffect(() => {
    if (isToggle) {
      if (address.verified && name.success && phone.success && email.success && year.success && make.success && model.success && quantity.success) {
        setIsAddBtnDisabled(false);
      } else {
        setIsAddBtnDisabled(true);
      }
    } else {
      if (address.verified && name.success && phone.success && email.success && vinValue.success) {
        setIsAddBtnDisabled(false);
      } else {
        setIsAddBtnDisabled(true);
      }
    }
  }, [
    address.verified,
    name.success,
    phone.success,
    email.success,
    vinValue.success,
    year.success,
    make.success,
    model.success,
    quantity.success,
    isToggle,
  ]);

  const getVehicleSubscriptions = () => {
    const vehicleFeature = [];
    const vehicleSubscriptions = [];
    Object.keys(productInfo).forEach((item) => {
      if (productInfo[item].featureType === "FEATURE" && productInfo[item].ProductName !== "Key Fob ID") {
        vehicleFeature.push({ materialId: productInfo[item].SAPProductID, techRefId: productInfo[item].TechRefId });
      }
    });
    Object.keys(productInfo).forEach((item) => {
      if (productInfo[item].featureType === "CORE") {
        vehicleSubscriptions.push({
          subscription: productInfo[item].SAPProductID,
          techRefId: productInfo[item].TechRefId,
          vehicleFeatures: [...vehicleFeature],
        });
      }
    });
    setVehicleSubscriptions(vehicleSubscriptions);
  };

  const getValidateVin = async (vinArray) => {
    setLoader(true);
    let payload = {
      billingCountry: cspDetails.cspDetails?.cspData?.data?.data?.BillingCountry,
      bundleName: productInfo[0].BundleName,
      vinList: vinArray,
    };
    let response = await validateVin(payload);
    if (response.status === 200 && response.data?.data) {
      setAllowedVins((prevArray) => [...prevArray, ...vinArray]);
      setVinValue({ value: "", error: false, errorText: "Enter name", success: false });
      let response = await validateVin(payload);
      let vinData = [...updatedVehicles];
      if (response.data.data.incompatibleVins) {
        response.data.data.incompatibleVins.map((item) => {
          vinData.push({
            vin: item.vin,
            year: "",
            make: "",
            model: "",
            weightClass: "",
            error: true,
            fuelType: "",
            killSwitch: killSwitch,
            emergency: ambulance,
            wheelChair: wheelChair,
            quantity: 1,
            errorMessage: "Incompatible for HD",
          });
        });
      }
      response.data.data.invalidVins.map((item) => {
        vinData.push({
          vin: item,
          year: "",
          make: "",
          model: "",
          weightClass: "",
          error: true,
          fuelType: "",
          killSwitch: killSwitch,
          emergency: ambulance,
          wheelChair: wheelChair,
          quantity: 1,
        });
      });
      response.data.data.validVins.map((item) => {
        vinData.push({
          vin: item.vin,
          year: item.year,
          make: item.make,
          model: item.model,
          weightClass: item.weightClass,
          fuelType: item.fuelType,
          error: false,
          killSwitch: killSwitch,
          emergency: ambulance,
          wheelChair: wheelChair,
          quantity: 1,
        });
      });
      let count = pendingAssignment - vinData.length;
      setBundleCount(count);
      setUpdatedVehicles(vinData);
      setDisableRight(false);
      setLoader(false);
    } else {
      setLoader(false);
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
    document.getElementById("RightSectionContainer")?.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getVehicleMakeData = async (value) => {
    setLoader(true);
    let payload = { country: cspDetails.cspDetails?.cspData?.data?.data?.BillingCountry, year: value };
    let response = await getVehicleMake(payload);
    if (response.status === 200 && response.data?.data?.length) {
      setMakeList(response?.data?.data);
      setLoader(false);
    } else {
      setLoader(false);
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
  };

  const getVehicleModelData = async (value, year) => {
    setLoader(true);
    let payload = { country: cspDetails.cspDetails?.cspData?.data?.data?.BillingCountry, year: year, make: value };
    let response = await getVehicleModel(payload);
    if (response.status === 200 && response.data?.data?.length) {
      setModelList(response?.data?.data);
      setLoader(false);
    } else {
      setLoader(false);
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
  };

  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 0) return "";
    if (digits.length > 10) return digits;
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const handleFields = (field, value, year, isAutoPopulated = false) => {
    switch (field) {
      case "Name": {
        if (value && value.length) {
          setName({ value, error: false, errorText: "Enter name", success: true });
        } else {
          setName({ value: "", error: true, errorText: "Enter name", success: false });
        }
        break;
      }
      case "Phone": {
        if (isAutoPopulated) {
          if (value && value.length) {
            setPhone({ value, error: false, errorText: "Enter phone number", success: true });
          } else {
            setPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
          }
        } else {
          const isIntlFormat = value.startsWith("+");
          if (isIntlFormat) {
            const rawDigits = value.replace(/[^0-9]/g, "");
            if (rawDigits.length === 0) {
              setPhone({ value: "+", error: true, errorText: "Enter +1 followed by 10 digits", success: false });
            } else {
              const forced = "1" + rawDigits.replace(/^1/, "");
              const cleaned = "+" + forced;
              const phoneDigits = forced.slice(1);
              if (phoneDigits.length === 10) {
                setPhone({ value: cleaned, error: false, errorText: "Enter phone number", success: true });
              } else if (phoneDigits.length > 10) {
                setPhone({ value: cleaned, error: true, errorText: "Only 10 digits allowed", success: false });
              } else {
                setPhone({ value: cleaned, error: true, errorText: "Enter +1 followed by 10 digits", success: false });
              }
            }
          } else {
            const digits = value.replace(/\D/g, "");
            const formatted = formatPhoneNumber(value);
            if (digits.length === 10) {
              setPhone({ value: formatted, error: false, errorText: "Enter phone number", success: true });
            } else if (digits.length > 10) {
              setPhone({ value: formatted, error: true, errorText: "Only 10 digits allowed", success: false });
            } else if (digits.length > 0) {
              setPhone({ value: formatted, error: true, errorText: "Enter 10 digit phone number", success: false });
            } else {
              setPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
            }
          }
        }
        break;
      }
      case "Email": {
        if (value && value.length) {
          if (EMAIL_REGEX_C360.test(value)) {
            setEmail({ value, error: false, errorText: "Enter email", success: true });
          } else {
            setEmail({ value, error: true, errorText: "Enter a valid email", success: false });
          }
        } else {
          setEmail({ value: "", error: true, errorText: "Enter email", success: false });
        }
        break;
      }

      case "Vin": {
        if (value && value?.length) {
          const arrayFromString = splitString(value.trim());
          //const found = arrayFromString.some((r) => allowedVins.includes(r));

          if (arrayFromString.length > bundleCount) {
            setVinValue({ value, error: true, errorText: bundleCount + " VINs allowed", success: false });
          } else {
            // Check for duplicates within the input
            const duplicateVins = arrayFromString.filter((vin, index) => arrayFromString.indexOf(vin) !== index);
            // Check for duplicates with already allowed VINs
            const alreadyExistingVins = arrayFromString.filter((vin) => allowedVins.includes(vin));

            if (duplicateVins.length > 0) {
              setVinValue({ value, error: true, errorText: `Duplicate VIN found: ${duplicateVins[0]}`, success: false });
            } else if (alreadyExistingVins.length > 0) {
              setVinValue({ value, error: true, errorText: `VIN already exists: ${alreadyExistingVins[0]}`, success: false });
            } else {
              // Validate each VIN format
              for (let i = 0; i < arrayFromString.length; i++) {
                if (!VIN_REGEX.test(arrayFromString[i]) || arrayFromString[i].length !== 17) {
                  setVinValue({ value, error: true, errorText: `Invalid VIN format: ${arrayFromString[i]}`, success: false });
                  break;
                } else {
                  setVinValue({ value, error: false, errorText: "", success: true });
                }
              }
            }
          }
        } else {
          setVinValue({ value: "", error: true, errorText: "Enter Vin", success: false });
        }
        break;
      }

      case "Year": {
        getVehicleMakeData(value);

        value && value.length
          ? setYear({ value, error: false, errorText: "Select year", success: true })
          : setYear({ value: "", error: true, errorText: "Select year", success: false });
        break;
      }

      case "Make": {
        getVehicleModelData(value, year);

        value && value.length
          ? setMake({ value, error: false, errorText: "Select make", success: true })
          : setMake({ value: "", error: true, errorText: "Select make", success: false });
        break;
      }

      case "Model": {
        value && value.length
          ? setModel({ value, error: false, errorText: "Select model", success: true })
          : setModel({ value: "", error: true, errorText: "Select model", success: false });
        break;
      }

      case "Quantity": {
        if (value && value.length) {
          if (QUANTITY_REGEX.test(value)) {
            if (value <= 0) {
              setQuantity({ value, error: true, errorText: "Enter valid quantity", success: false });
            } else if (value > bundleCount) {
              setQuantity({ value, error: true, errorText: " Can not be greater than " + bundleCount, success: false });
            } else {
              setQuantity({ value, error: false, errorText: "Enter quantity", success: true });
            }
          } else {
            setQuantity({ value: "", error: false, errorText: "", success: "" });
          }
        } else {
          setQuantity({ value: "", error: true, errorText: "Enter quantity", success: false });
        }
        break;
      }

      case "Check1": {
        setWheelChair(!wheelChair);
        break;
      }

      case "Check2": {
        setKillSwitch(!killSwitch);
        break;
      }

      case "Check3": {
        setAmbulance(!ambulance);
        break;
      }
    }
  };

  const splitString = (str) => {
    return str.split(/[,-\s_;]+/);
  };

  const hasDuplicates = (array) => {
    return new Set(array).size !== array.length;
  };

  const handleAddClick = () => {
    if (!isToggle) {
      const arrayFromString = splitString(vinValue.value.trim());
      getValidateVin(arrayFromString);
    } else {
      let vinData = [...updatedVehicles];
      let index = vinData.findIndex((item) => item.year === year.value && item.make === make.value && item.model === model.value);
      if (index !== -1) {
        vinData[index].quantity = parseInt(vinData[index].quantity) + parseInt(quantity.value);
        vinData[index].wheelChair = wheelChair;
        vinData[index].killSwitch = killSwitch;
        vinData[index].emergency = ambulance;
      } else {
        for (let i = 0; i < parseInt(quantity.value); i++) {
          vinData.push({
            ind: generate(),
            vin: "",
            year: year.value,
            make: make.value,
            model: model.value,
            weightClass: "",
            error: false,
            fuelType: "",
            killSwitch: killSwitch,
            emergency: ambulance,
            wheelChair: wheelChair,
            quantity: 1,
          });
        }
      }
      setBundleCount((prevCount) => prevCount - quantity.value);
      setUpdatedVehicles(vinData);
      setYear({ value: "", error: false, errorText: "Select year", success: false });
      setMake({ value: "", error: false, errorText: "Select make", success: false });
      setModel({ value: "", error: false, errorText: "Select model", success: false });
      setQuantity({ value: "", error: false, errorText: "Enter quantity", success: false });
      setDisableRight(false);
    }
    document.getElementById("RightSectionContainer")?.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getYearRange = () => {
    const startYear = 1981;
    const endYear = new Date().getFullYear() + 1;
    const years = [];

    for (let i = startYear; i <= endYear; i++) {
      years.push(i);
    }
    setYearList(years);
  };
  const showActionIcon = (row) => (
    <FlexRow>
      <div
        onClick={() => {
          deleteRow(row);
        }}
        data-testid="delete-row"
      >
        <Icon
          className="trash-icon"
          aria-label="Delete"
          alt="delete-icon"
          name="trash"
          size="medium"
          color="#000000"
          style={{ cursor: "pointer", outline: "none" }}
        />
      </div>
    </FlexRow>
  );
  const handleSaveClick = async () => {
    setLoader(true);
    let payload = {
      vinList: updatedVehicles,
      registrationNumber: "",
      accountId: cspDetails.cspDetails.accountId,
      type: "VEHICLE",
      vehicleAssetName: "",
      address1: address.address1.value,
      address2: address.address2.value,
      city: address.city.value,
      country: address.country.value.description,
      countryCode: address.country.value.code,
      stateCode: address.state.value.erpStateCode,
      zipCode: address.zip.value,
      timezone: address.timezone,
      addressByPass: address.addressByPass,
      locationFound: address.locationFound,
      locusLocationId: address.locusLocationId,
      locusSuggestedAddress: address.locusSuggestedAddress,
      latitude: address.latitude,
      longitude: address.longitude,
      customerName: name.value,
      customerEmail: email.value,
      customerPhone: phone.value,
      createdBy: `${cspDetails.cspDetails.firstName} ${cspDetails.cspDetails.lastName}`,
      sourceApplication: "C360",
      salesOrgId: cspDetails.cspDetails.cspData.data.data.CSP[0].Opp_Sales_Org,
      bundleId: productInfo[0].BundleId,
      bundleOrderType: productInfo[0].OrderDetailType,
      productPlatform: cspDetails.cspDetails.cspData.data.data.ProductPlatform,
      accountBrand: cspDetails.cspDetails.cspData.data.data.Account_Brand,
      crmRefId: cspDetails.cspDetails.cspData.data.data.CSP[0].CRM_Ref_ID,
      vehicleSubscriptions: vehicleSubscriptions,
    };
    let response = await saveVin(payload);
    if (response && response.status === 200) {
      setUpdatedVehicles([]);
      switchTab(1);
    } else if (response && response.status === 406) {
      notify(response?.data?.message, "error");
    } else if (response && response.status === 500 && response?.data?.message !== "Unable to save Part Recommendation") {
      notify("We did not receive the recommendation from the HWS system, please check with the team if this vehicle is qualified.", "error");
    } else {
      notify("Error saving VIN", "error");
    }
    setLoader(false);
  };
  const handleCancelClick = () => {
    setUpdatedVehicles([]);
    switchTab(1);
  };
  const deleteRow = (row) => {
    let vinData = [...updatedVehicles];
    if (row.vin !== "" || row.vin === undefined || row.vin === null) {
      vinData = vinData.filter((item) => item.vin !== row.vin);
      setAllowedVins((prevArray) => prevArray.filter((item) => item !== row.vin));
    } else {
      let index = vinData.findIndex((item) => item.ind === row.ind && item.year === row.year && item.make === row.make && item.model === row.model);
      vinData.splice(index, 1);
    }
    setUpdatedVehicles(vinData);
    if (vinData.length === 0) {
      setDisableRight(true);
      setBundleCount(pendingAssignment);
    } else {
      setBundleCount(pendingAssignment - vinData.length);
    }
  };
  const addMoreVehicles = () => {
    if (bundleCount > 0) {
      setDisableRight(true);
    }
  };
  const deleteAll = () => {
    setDeleteModalOpened(true);
  };
  const closeDeleteModal = () => {
    setDeleteModalOpened(false);
  };
  const handleConfirmDelete = () => {
    setUpdatedVehicles([]);
    setAllowedVins([]);
    setBundleCount(pendingAssignment);
    setDisableRight(true);
    closeDeleteModal();
  };
  return (
    <>
      <div>
        {notification}
        <Loader active={isLoading} fullscreen />
        <FlexRow onClick={handleCancelClick} data-testid="close-icon" justifyContent="end">
          <Icon
            aria-label="close"
            alt="close-icon"
            role="img"
            name="close"
            size="medium"
            color="#000000"
            style={{ cursor: "pointer", outline: "none" }}
          />
        </FlexRow>
        <FlexRow style={{ width: "auto" }}>
          <FlexColumn style={{ width: "38%", borderRight: "1px solid black" }}>
            <FullWidthFormSection
              style={{ pointerEvents: !disableRight ? "none" : null, opacity: !disableRight ? "0.5" : "" }}
              disabled={!disableRight}
            >
              <Title level={3} style={{ marginTop: "0px" }}>
                {productInfo[0]?.BundleName}
              </Title>
              <SmallText>{featureValues}</SmallText>
              <SmallText>{pendingAssignment} Vehicles Pending Assignment</SmallText>
              <ValidateVehicleAddress address={address} setAddress={setAddress} showHistoricalAddressDropdown={true} setLoader={setLoader} />
              <SLGridLayout>
                <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}>
                  <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
                    <CustomInput
                      width="100%"
                      type="text"
                      label="Contact Name*"
                      aria-label="Contact Name"
                      error={name.error}
                      errorText={name.errorText}
                      success={name.success}
                      value={name.value}
                      maxLength={50}
                      css={{ paddingRight: "10px" }}
                      onChange={(event) => handleFields("Name", event.target.value, "")}
                    />
                  </CompactCol>
                  <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
                    <CustomInput
                      width="100%"
                      type="text"
                      label="Phone*"
                      aria-label="Phone"
                      maxLength={16}
                      error={phone.error}
                      errorText={phone.errorText}
                      success={phone.success}
                      value={phone.value}
                      onChange={(event) => handleFields("Phone", event.target.value, "")}
                    />
                  </CompactCol>
                  <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                    <CustomInput
                      width="100%"
                      type="text"
                      label="Email*"
                      aria-label="Email"
                      error={email.error}
                      errorText={email.errorText}
                      success={email.success}
                      value={email.value}
                      onChange={(event) => handleFields("Email", event.target.value, "")}
                    />
                  </CompactCol>
                </SLRowLayout>
              </SLGridLayout>
              <FlexRow style={{ paddingLeft: "10px", marginTop: "12px", marginBottom: "4px", alignItems: "center" }}>
                <span style={{ fontSize: "12px", fontWeight: "bold", lineHeight: "1" }}>VIN</span>
                <Toggle
                  value="default"
                  surface="light"
                  data-testid="toggle-btn"
                  disabled={false}
                  showText={false}
                  textWeight="regular"
                  textSize="small"
                  textPosition="left"
                  css={{ marginLeft: "8px", marginRight: "8px" }}
                  onChange={() => setIsToggle(!isToggle)}
                />
                <span style={{ fontSize: "12px", fontWeight: "bold", lineHeight: "1" }}>YMM</span>
              </FlexRow>
              {!isToggle ? (
                <SLGridLayout>
                  <SLRowLayout css={{ paddingLeft: "10px !important" }}>
                    <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                      <TextArea
                        value={vinValue.value}
                        label="VINs*"
                        data-testid="vin-textarea"
                        error={vinValue.error}
                        errorText={vinValue.errorText}
                        success={vinValue.success}
                        minHeight="1X"
                        width="100%"
                        css={{ fontSize: "12px !important", width: "100%", maxWidth: "100%", "& *": { maxWidth: "100%" } }}
                        maxLength={500}
                        helperText="Enter multiple VINs separated by commas or new lines"
                        helperTextPlacement="bottom"
                        onChange={(event) => handleFields("Vin", event.target.value, "")}
                      />
                    </CompactCol>
                  </SLRowLayout>
                </SLGridLayout>
              ) : (
                <>
                  <SLGridLayout>
                    <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}>
                      <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 4 }}>
                        <CustomDropdown
                          label="Year*"
                          value={year.value ? year.value : "Please select"}
                          errorText={year.errorText}
                          error={year.error}
                          success={year.success}
                          onChange={(e) => handleFields("Year", e.target.value, "")}
                          marginBottom="10px"
                          paddingRight="5px"
                        >
                          <option disabled>Please select</option>
                          {yearList.map((record) => (
                            <option key={record} value={record}>
                              {record}
                            </option>
                          ))}
                        </CustomDropdown>
                      </CompactCol>
                      <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 4 }}>
                        <CustomDropdown
                          label="Make*"
                          value={make.value ? make.value : "Please select"}
                          errorText={make.errorText}
                          error={make.error}
                          success={make.success}
                          onChange={(e) => handleFields("Make", e.target.value, year.value)}
                          marginBottom="10px"
                          paddingRight="5px"
                        >
                          <option disabled>Please select</option>
                          {makeList.map((record) => (
                            <option key={record} value={record}>
                              {record}
                            </option>
                          ))}
                        </CustomDropdown>
                      </CompactCol>
                      <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 4 }}>
                        <CustomDropdown
                          label="Model*"
                          value={model.value ? model.value : "Please select"}
                          errorText={model.errorText}
                          error={model.error}
                          success={model.success}
                          onChange={(e) => handleFields("Model", e.target.value, "")}
                          marginBottom="10px"
                        >
                          <option disabled>Please select</option>
                          {modelList.map((record) => (
                            <option key={record} value={record}>
                              {record}
                            </option>
                          ))}
                        </CustomDropdown>
                      </CompactCol>
                    </SLRowLayout>
                  </SLGridLayout>
                  <SLGridLayout>
                    <SLRowLayout css={{ paddingLeft: "10px !important" }}>
                      <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                        <CustomInput
                          width="100%"
                          type="text"
                          label="Quantity*"
                          aria-label="Quantity"
                          error={quantity.error}
                          errorText={quantity.errorText}
                          success={quantity.success}
                          value={quantity.value}
                          onChange={(event) => handleFields("Quantity", event.target.value, "")}
                        />
                      </CompactCol>
                    </SLRowLayout>
                  </SLGridLayout>
                </>
              )}

              <SLGridLayout>
                <SLRowLayout css={{ marginTop: ".1rem", paddingLeft: "10px !important" }}>
                  <CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 12 }}>
                    <SLGridLayout>
                      <SLRowLayout css={{ marginTop: ".1rem", paddingLeft: "10px !important" }}>
                        <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 2 }}>
                          <StatusWrapper>
                            <Icon
                              className="trash-icon"
                              aria-label="InternationalSymbolOfAccess"
                              alt="InternationalSymbolOfAccess"
                              name="international-symbol-of-access"
                              size="XLarge"
                              style={{ cursor: "pointer", outline: "none", width: "1.3rem", blockSize: "1.3rem" }}
                              color="#000000"
                            />
                            <CustomCheckbox
                              role="checkbox"
                              data-testid="wheelChair-checkbox"
                              aria-checked={wheelChair}
                              width="10px"
                              error={false}
                              errorText=""
                              value={wheelChair}
                              selected={wheelChair}
                              onChange={(e) => handleFields("Check1", e.target.value, "")}
                            />
                          </StatusWrapper>
                        </CompactCol>
                        <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 2 }}>
                          <StatusWrapper>
                            <Icon
                              className="smart-switch"
                              aria-label="smart-switch"
                              alt="smart-switch"
                              name="smart-switch"
                              size="Large"
                              color="#000000"
                              style={{ cursor: "pointer", outline: "none", width: "1.3rem", blockSize: "1.3rem" }}
                            />
                            <CustomCheckbox
                              role="checkbox"
                              data-testid="killSwitch-checkbox"
                              aria-checked={killSwitch}
                              width="10px"
                              error={false}
                              errorText=""
                              value={killSwitch}
                              selected={killSwitch}
                              onChange={(e) => handleFields("Check2", e.target.value, "")}
                            />
                          </StatusWrapper>
                        </CompactCol>
                        <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 2 }}>
                          <StatusWrapper>
                            <Icon
                              className="police-fleet"
                              aria-label="police-fleet"
                              alt="police-fleet"
                              name="police-fleet"
                              size="Large"
                              color="#000000"
                              style={{ cursor: "pointer", outline: "none", width: "1.3rem", blockSize: "1.3rem" }}
                            />
                            <CustomCheckbox
                              role="checkbox"
                              data-testid="ambulance-checkbox"
                              aria-checked={ambulance}
                              width="10px"
                              error={false}
                              errorText=""
                              value={ambulance}
                              selected={ambulance}
                              onChange={(e) => handleFields("Check3", e.target.value, "")}
                            />
                          </StatusWrapper>
                        </CompactCol>
                        <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 2 }}></CompactCol>
                        <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 2 }}></CompactCol>
                        <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 2 }}>
                          <FlexRow justifyContent="end">
                            <Button
                              style={{ marginTop: "7px" }}
                              role="button"
                              size="small"
                              aria-label="addButton"
                              disabled={isAddBtnDisabled}
                              ariaDisabled={isAddBtnDisabled}
                              onClick={handleAddClick}
                            >
                              Add
                            </Button>
                          </FlexRow>
                        </CompactCol>
                      </SLRowLayout>
                    </SLGridLayout>
                  </CompactCol>
                </SLRowLayout>
              </SLGridLayout>
            </FullWidthFormSection>
          </FlexColumn>
          <FlexColumn style={{ width: "62%" }}>
            <div
              style={{ margin: "1rem", marginTop: 0, pointerEvents: disableRight ? "none" : null, opacity: disableRight ? "0.5" : "" }}
              disabled={disableRight}
            >
              <Title level={3} style={{ marginTop: "0px" }}>
                {updatedVehicles.some((item) => item.error === true) ? "Assign Vehicles to Bundle & Address" : "Vehicles To Be Added"}
              </Title>
              <MediumText style={{ marginTop: "1rem" }}>
                Ship to <span style={{ fontSize: "14px", fontWeight: "bold" }}>{name.value}</span> at{" "}
                <span style={{ fontSize: "14px", fontWeight: "bold" }}>{address.address1.value}</span>
              </MediumText>
              <AddVehicleAssignmentGrid
                rows={updatedVehicles.sort((a, b) => b.error - a.error)}
                columns={ADD_VEHICELS_ASSIGNMENT_LIST_COLS}
                updatedVehicles={updatedVehicles}
                setUpdatedVehicles={setUpdatedVehicles}
                showActionIcon={showActionIcon}
                handleSaveClick={handleSaveClick}
                addMoreVehicles={addMoreVehicles}
                deleteAll={deleteAll}
                pendingVehicleCount={bundleCount}
                allowedVins={allowedVins}
                setAllowedVins={setAllowedVins}
                payload={{ billingCountry: cspDetails.cspDetails?.cspData?.data?.data?.BillingCountry, bundleName: productInfo[0].BundleName }}
              />
            </div>
          </FlexColumn>
        </FlexRow>
      </div>
      <>
        {deleteModalOpened && (
          <DeleteModal isOpen={deleteModalOpened} onClose={closeDeleteModal} title="Delete All" handleConfirmDelete={handleConfirmDelete} />
        )}
      </>
    </>
  );
}

export const AddVehicleAssignmentMetadata = {
  name: "Add Vehicle Assignment",
  id: "Add_Vehicle_Assignment",
  component: lazy(() => import("./AddVehicleAssignment")),
  route: "/connect360/add-vehicle-assignment",
  breadcrumbs: false,
};
